import { render } from "./quiz-v1-multiple-choice.vue?vue&type=template&id=e11232ee&scoped=true"
import script from "./quiz-v1-multiple-choice.vue?vue&type=script&lang=js"
export * from "./quiz-v1-multiple-choice.vue?vue&type=script&lang=js"

import "./quiz-v1-multiple-choice.vue?vue&type=style&index=0&id=e11232ee&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e11232ee"]])

export default __exports__